import { css } from "styled-components";
import { responsiveArraySpreader } from "../../utils";

var gridPositioning = css(["display:grid;justify-self:", ";align-self:", ";justify-items:", ";align-items:", ";"], function (_ref) {
  var justifySelf = _ref.justifySelf;
  return justifySelf || "stretch";
}, function (_ref2) {
  var alignSelf = _ref2.alignSelf;
  return alignSelf || "stretch";
}, function (_ref3) {
  var justifyItems = _ref3.justifyItems;
  return justifyItems || "start";
}, function (_ref4) {
  var alignItems = _ref4.alignItems;
  return alignItems || "start";
});

var gridSpanSpaceVertical = css(["", " ", "  ", " ", " "], function (props) {
  return responsiveArraySpreader(function (value, valueTwo) {
    return valueTwo && css(["margin-left:-", "rem;"], value);
  }, props.theme.globalSitePadding, props.spanMarginLeftArray);
}, function (props) {
  return responsiveArraySpreader(function (value, valueTwo) {
    return valueTwo && css(["padding-left:", "rem;"], value);
  }, props.theme.globalSitePadding, props.addPaddingLeftArray);
}, function (props) {
  return responsiveArraySpreader(function (value, valueTwo) {
    return valueTwo && css(["margin-right:-", "rem;"], value);
  }, props.theme.globalSitePadding, props.spanMarginRightArray);
}, function (props) {
  return responsiveArraySpreader(function (value, valueTwo) {
    return valueTwo && css(["padding-right:", "rem;"], value);
  }, props.theme.globalSitePadding, props.addPaddingRightArray);
});

export var layoutGridMixins = {
  gridPositioning: gridPositioning,
  gridSpanSpaceVertical: gridSpanSpaceVertical
};